import React from "react";
import { Link } from "react-router-dom";
import "./menuLeftPhoneLealtad.css";
//
import logo from "../../../Lealtad/assets/logo/logo2.png";
//
import { MdOutlineAttachMoney } from "react-icons/md";
import {
  FaFileSignature,
  FaClipboardList,
  FaUserAlt,
  FaHandsHelping,
} from "react-icons/fa";
import { FaDeleteLeft } from "react-icons/fa6";
import { GoFileSubmodule } from "react-icons/go";
import { RiLockPasswordFill } from "react-icons/ri";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";

const MenuPhoneProvComerLealtad = ({ viewSee }) => {
  const navigate = useNavigate();

  const changeviewprov = (e, page) => {
    e.preventDefault();
    viewSee(page);
  };

  const handleLogout = () => {
    Cookies.remove("token");
    Cookies.remove("adminType");
    sessionStorage.removeItem("Data");
    navigate("/");
  };

  return (
    <div className="boxphonemenucellealtad">
      <div>
        <div className="boxlogophonemenulealtad">
          <img src={logo} alt="logo" />
        </div>
        <div className="flexbuttonsphonelealtad">
          <div className="buttonsphonelealtad">
            <Link to="/portal-comercializadores-lealtad/mis-ventas">
              <p className="textcellealtad">
                <MdOutlineAttachMoney className="phoneiconlealtad" />
                Mis ventas
              </p>
            </Link>
          </div>
          <div
            className="buttonsphonelealtad"
            onClick={(e) => changeviewprov(e, "Perfil")}
          >
            <p className="textcellealtad">
              <FaUserAlt className="phoneiconlealtad" />
              Perfil
            </p>
          </div>
        </div>
        <div className="flexbuttonsphonelealtad">
          <div
            className="buttonsphonelealtad"
            onClick={(e) => changeviewprov(e, "Convenio")}
          >
            <p className="textcellealtad">
              <FaFileSignature className="phoneiconlealtad" />
              Convenio con entidad
            </p>
          </div>
          <div
            className="buttonsphonelealtad"
            onClick={(e) => changeviewprov(e, "Factura")}
          >
            <p className="textcellealtad">
              <FaHandsHelping className="phoneiconlealtad" />
              Subir factura
            </p>
          </div>
        </div>
        <div className="flexbuttonsphonelealtad">
          <div
            className="buttonsphonelealtad"
            onClick={(e) => changeviewprov(e, "Documentacion")}
          >
            <p className="textcellealtad">
              <GoFileSubmodule className="phoneiconlealtad" />
              Mi documentacion
            </p>
          </div>

          <div className="buttonsphonelealtad buttonfinallealtad">
            <p className="textcellealtad">
              <RiLockPasswordFill className="phoneiconlealtad" />
              Cambiar <br /> contraseña
            </p>
          </div>
        </div>

        <div className="flexbuttonsphonelealtad">
          <Link to="/portal-comercializadores-lealtad/mis-facturas">
            <div className="buttonsphonelealtad">
              <p className="textcellealtad">
                <FaClipboardList className="phoneiconlealtad" />
                Mis facturas
              </p>
            </div>
          </Link>
          <div
            className="buttonsphonelealtad buttonfinallealtad"
            onClick={handleLogout}
          >
            <p className="textcellealtad">
              <FaDeleteLeft className="phoneiconlealtad" />
              Salir
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MenuPhoneProvComerLealtad;
